function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3519",
  "data-name": "Path 3519",
  d: "M102.844,0H9.281V-18.562L53.438-65.625A108.933,108.933,0,0,0,66.891-82.969q4.359-7.406,4.359-14.062,0-9.094-4.594-14.3t-13.125-5.2q-9.187,0-14.484,6.328t-5.3,16.641H6.563a44.75,44.75,0,0,1,5.953-22.781,41.958,41.958,0,0,1,16.828-16.172A51.148,51.148,0,0,1,54-138.375q21.094,0,32.766,10.125T98.438-99.656a45.9,45.9,0,0,1-5.25,20.625q-5.25,10.5-18,24.469L44.156-21.844h58.688Z",
  transform: "translate(-6.563 138.375)",
  fill: "#f37320",
  opacity: 0.1
});

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.281,
    height: 138.375,
    viewBox: "0 0 96.281 138.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0b5a95bca75fb22841ceab5096ff0adb.svg";
export { ForwardRef as ReactComponent };